/**
 * Environment configuration for the GCD application
 * This file centralizes all environment variable access
 */

// Starget client configuration
export const STARGET_CLIENT_ID = process.env.VUE_APP_GCD_STARGET_CLIENT_ID;

export const STARGET_CLIENT_SECRET_ID = (() => {
  const envVar = process.env.VUE_APP_GCD_STARGET_CLIENT_SECRET_ID;
  return envVar && envVar !== "undefined" ? envVar : undefined;
})();

// RUM Dashboard API token
export const RUM_DASHBOARD_API_TOKEN = process.env.VUE_APP_GCD_RUM_DASHBOARD_API_TOKEN;

// File operations client configuration
export const FILE_OPS_CLIENT_ID = process.env.VUE_APP_FILE_OPS_CLIENT_ID;
export const FILE_OPS_CLIENT_SECRET = process.env.VUE_APP_FILE_OPS_CLIENT_SECRET;
export const FILE_OPS_TENANT_ID = process.env.VUE_APP_FILE_OPS_TENANT_ID;
export const FILE_OPS_TOKEN_PATH = process.env.VUE_APP_FILE_OPS_TOKEN_PATH;
export const FILE_OPS_SCOPE = process.env.VUE_APP_FILE_OPS_SCOPE;

// Main application configuration
export const CLIENT_ID = process.env.VUE_APP_CLIENT_ID;
export const X_API_KEY = process.env.VUE_APP_X_API_KEY;
export const APP_AUTHORITY = process.env.VUE_APP_APP_AUTHORITY;
export const X_APP_ID = process.env.VUE_APP_X_APP_ID;
